import { render, staticRenderFns } from "./Receipt-products-search.vue?vue&type=template&id=a3545370&scoped=true"
import script from "./Receipt-products-search.vue?vue&type=script&lang=js"
export * from "./Receipt-products-search.vue?vue&type=script&lang=js"
import style0 from "./Receipt-products-search.vue?vue&type=style&index=0&id=a3545370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3545370",
  null
  
)

export default component.exports